<template>
    <div class="p-grid data-table data-table-list">
        <div class="profile-account p-col-12">


            <div class="form-item">
                <label for="sumausd">USD: </label>
                <InputText id="sumausd" placeholder="0" :value="sumausd" disabled />
            </div>
            <div class="form-item">
                <label for="sumaxbt">BTC: </label>
                <InputText id="sumaxbt" placeholder="0" :value="sumaxbt" disabled />
            </div>
            <!--<span>* not including ETH bots (in BTC sum)</span>-->


        </div>
        <div class="p-col-12">
            <div class="card card-w-title">
                <DataTable :value="stats" class="p-datatable-responsive p-col-12  " :paginator="true" :rows="50" :filters="filters" :autoLayout="true">
                    <template #header>
                        <h2>List of bots</h2>
                    </template>
                    <Column field="pingtime" header="Time:" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ formatDate(slotProps.data.PingTime) }}</span>
                        </template>
                    </Column>
                    <Column field="strategyname" header="Strategy name" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.StrategyName }}</span>
                        </template>
                    </Column>
                    <Column field="position" header="Position:" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.Position }}</span>
                        </template>
                    </Column>
                    <Column field="stanjeusd" header="USD:" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ formatCurrency(slotProps.data.StanjeUSD) }}</span>
                        </template>
                    </Column>
                    <Column field="stanjexbt" header="BTC:" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.StanjeXBT }}</span>
                        </template>
                    </Column>
                    <Column field="stanjecontracts" header="Contracts position:" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.StanjeContracts }}</span>
                        </template>
                    </Column>
                    <Column field="stanjereserved" header="Contracts reserved:" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.StanjeReserved }}</span>
                        </template>
                    </Column>
                    <Column field="username" header="User:" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.Username }}</span>
                        </template>
                    </Column>

                 

                    <!-- <Column v-for="col of columns" :field="col.field" :header="col.header" :key="col.field">
        <template #editor="slotProps">
            <InputText :value="slotProps.data[slotProps.column.field]" />
        </template>
    </Column> -->
                </DataTable>
            </div>
        </div>
        <div class="p-col-12" >
            <button>
                <span title="User view" @click="$router.push('/user/overview')"> USER VIEW</span>
            </button>
        </div>



    </div>
</template>

<script>

    import McbotService from '../../service/McbotService';

    export default {
        data() {
            return {
                sumausd: 0,
                sumaxbt: 0,
                stats: null,
                filters: {},
                activeRow: {},
                display: false,
                title: '',
                // columns: null
            }
        },
        created() {
            this.mcbotService = new McbotService();
            this.$store.commit('setPageTitle', { pageTitle: 'Overview' });
        },
        async mounted() {

            var t = await this.mcbotService.sumUSD();
            this.sumausd = t[0].suma;
            t = this.sumaxbt = await this.mcbotService.sumXBT();
            this.sumaxbt = t[0].suma;
            
            this.stats = await this.mcbotService.getAll();

            this.stats.forEach(popuni);

            function popuni(item, index) {
                item.Position = 'TEST';

                if (item.StanjeContracts == item.ContractsFiatStanje) item.Position = 'NEUTRAL';
                if (item.StanjeContracts == item.ContractsFiatStanje - item.PaketSize) item.Position = 'SHORT';
                if (item.StanjeContracts == item.ContractsFiatStanje + item.PaketSize) item.Position = 'LONG';

                if (item.StanjeReserved > item.StanjeContracts) item.Position = 'ORDER (long)';
                if (item.StanjeReserved < item.StanjeContracts) item.Position = 'ORDER (short)';
            }
            
            //console.log(this.stats);
        },
        methods: {
         

            formatDate(date) {
                var d = new Date(date),
                    month = "" + (d.getMonth() + 1),
                    day = "" + d.getDate(),
                    year = d.getFullYear(),
                    hours = "" + d.getHours(),
                    mins = "" + d.getMinutes();

                if (month.length < 2) month = "0" + month;
                if (day.length < 2) day = "0" + day;
                if (hours.length < 2) hours = "0" + hours;
                if (mins.length < 2) mins = "0" + mins;

                return [year, month, day].join("-") + " " + hours + ":" + mins;
            },


            formatCurrency(value) {
                return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'USD' }).format(value);
            },
        }
    }

</script>

<style scoped>

</style>